import { useState, useEffect } from 'react';
import { Card, Tooltip } from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import TagsDrawer from '../../Common/TagsDrawer';
import MergeModal from '../../Common/MergeModal';
import utils from '../../Common/utils';
import { Table, Button, Space} from 'antd';
import {EditFilled} from '@ant-design/icons';
import {PlusOutlined, MergeCellsOutlined} from '@ant-design/icons';
import { setInitialFilterConf } from '../../slices/filters/thunk'
import { loadTags as reloadTagsGlobal } from '../../slices/thunk';
import { useSelector, useDispatch } from "react-redux";


const api = new APIClient();


const TagsList = () => {
  document.title = "Oznake" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [tagsData, setTagsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const searchPending = useSelector((state) => state.Filterdata.searchPending)
  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Only the normal search box.
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      disabled: []
    }))
  }, []);
  const loadTags = () => {
    setLoading(true);
    api.get('/api/tags/tree/', filterdata)
      .then((resp) => setTagsData(Array.isArray(resp) ? resp : []))
      .finally(() => setLoading(false));
  }

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }

  const columns = [
    {
      title: 'Naziv',
      dataIndex: 'title',
      render: (title, r) => (
        <Space size={6}>
          <span style={{
            display: 'inline-block', width: 10, height: 10,
            borderRadius: 2, background: r.color_hex || '#808080'
          }} />
          {title}
        </Space>
      )
    },
    {title: 'Uredi', key: 'edit', render: r => <Button size='small' onClick={ev => onEdit(r.id)}><EditFilled/></Button>}
  ]


  useEffect(() => {
      loadTags()
  }, [filterdata]);


  return (
    <>
      <TagsDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedId(null);
        }}
        onDone={() => {
          loadTags(filterdata);
          setEditedId(null);
          setOpen(false);
        }}
        id={editedId}
      />

      <MergeModal
        open={mergeModalOpen}
        title='Združevanje oznak'
        mergeApiUrl={"/api/tags/merge/"}
        mergeInfoApiUrl={"/api/tags/merge_info/"}
        items={utils.flattenTags(tagsData).filter(x => selectedIds.includes(x.id))}
        onCancel={() => setMergeModalOpen(false)}
        onDone={() => {
          loadTags(filterdata);
          dispatch(reloadTagsGlobal());
          setMergeModalOpen(false);
        }}
        id={editedId}
      />

      <Breadcrumb parentTitle="Šifranti" pageTitle="Oznake" />

      <Card
        title='Oznake'
        extra={
          <Space>
            <Tooltip title={'Izberi oznake za združevanje!'}>
              <Button
                disabled={selectedIds.length == 0}
                onClick={ev => setMergeModalOpen(true)}
                icon={<MergeCellsOutlined />}
              />
            </Tooltip>
            <Button
              onClick={ev => {
                setEditedId(null)
                setOpen(true)
              }}
              icon={<PlusOutlined />}
            />
          </Space>
        }
      >
        <Table
            size="small"
            loading={loading || searchPending}
            columns={columns}
            dataSource={tagsData || []}
            pagination={false}
            rowKey={obj => obj.id}
            expandable={{ defaultExpandAllRows: true }}
            rowSelection={{
            checkStrictly: true,
            onChange: (selectedIds) => {
              setSelectedIds(selectedIds)
            }}}
            rowClassName={(record) => {}}
        />
      </Card>
    </>
  )
}

export default TagsList;
